const crypto = require('crypto')
import Cookie from '@/utils/cookie'
import Consts from '@/common/consts'
import TbKeyJson from '@/assets/tb_key.json'
const Help = {}

export function getMd5(s) {
  // md5加密
  try {
    let md5 = crypto.createHash('md5')
    md5.update(s)
    return md5.digest('hex').toUpperCase() // 32位大写
  } catch (error) {
    console.log(error)
    return ''
  }
}

/**
 * 获取分页数据
 * @param currentPage
 * @param obj
 * @param result
 */
export function getPageData(currentPage, obj, result) {
  if (result.hasOwnProperty('per_page_count')) {
    obj.pageSize = result.per_page_count
  } else {
    obj.pageSize = result.pageSize
  }
  obj.total_count = result.total_count
  if (currentPage === 1) {
    // 加载第1页
    obj.data = result.data
    obj.loadMore = true
    obj.currentPage = 1
  } else {
    // 加载下一页
    if (result.data.length > 0) {
      obj.currentPage = currentPage
      obj.data.push(...result.data)
    }
  }
  obj.loadMore = !(currentPage * obj.pageSize >= result.total_count)
  return obj
}

export function isNull(s) {
  /** 判断字符串是否为空 */
  if (typeof s === 'undefined' || s === null || s.length === 0) {
    return true
  } else {
    return false
  }
}
/**
 * 格式化字符串金额(单位:元)
 * @param {string} str
 */
export function formatStrAmount(str) {
  if (str !== null || !isNaN(str)) {
    try {
      return parseFloat(parseFloat(str).toFixed(2))
    } catch (err) {
      return str
    }
  } else {
    return str || ''
  }
}
/**
 * px2rem
 * @param {Number} px
 * 例如: 屏幕宽度375, px为40
 * (750 / 375) * 40 / 100
 */
export function px2rem(px) {
  const winWidth = window.innerWidth || document.body.clientWidth // 屏幕宽度
  return ((750 / winWidth) * px) / 100
}
/**
 * rem2px
 * @param {Number} rem
 * 例如: 屏幕宽度375, rem为0.8
 * px = (375 / 750) * 100 * 0.8
 */
export function rem2px(rem) {
  const winWidth = window.innerWidth || document.body.clientWidth // 屏幕宽度
  return (winWidth / 750) * 100 * rem
}

export function getHiddenPhone(phone) {
  // 手机号隐藏中间4位数字
  return phone.replace(/^(\d{3})\d{4}(\d+)/, '$1****$2')
}
export function checkPhone(n) {
  // 判断是否为手机号
  return /^1[3456789]\d{9}$/.test(n)
}
/**
 * 获取指定样式的cdn图片
 */
export function getCdnImgByStyle(imgUrl, style) {
  if (imgUrl) {
    return `${httpsImg(imgUrl)}?x-oss-process=style/${style}`
  }
  return ''
}

export function httpsImg(imgUrl) {
  // 获取cdn图片的https链接
  let arr = [
    'tupian.dshui.cc',
    'dsh-wap.oss-cn-hangzhou.aliyuncs.com',
    'dshui-test.oss-cn-hangzhou.aliyuncs.com',
    'dshui-wap.oss-cn-hangzhou.aliyuncs.com',
  ]
  for (let i = 0; i < arr.length; i++) {
    let a = `http://${arr[i]}`
    if (imgUrl.indexOf(a) > -1) {
      return imgUrl.replace(a, `https://${arr[i]}`)
    }
  }
  return imgUrl
}

/**
 * 保存推荐人的邀请码
 * @param {string} routeQuery 路由参数
 */
export function saveInviterUnionID(routeQuery) {
  let unionID = ''
  if (routeQuery && routeQuery['unionID'] && routeQuery['unionID'].indexOf('dsh_') > -1) {
    // 路由参数中包含推广码
    unionID = routeQuery['unionID'].replace('dsh_', '')
  } else {
    // 二级域名中包含推广码(店铺ID)
    const domain = window.location.hostname
    let regex = /shop[0-9]+\.dshui\.com/g
    let arr = domain.match(regex)
    if (arr) {
      let str = arr[0].replace(/\.dshui\.com/g, '')
      unionID = str.replace('shop', '')
    }
  }
  if (unionID) {
    Cookie.set(Consts.COOKIE_INVITER_UNIONID, unionID)
  }
}

/**
 * 获取推荐人的邀请码
 */
export function getInviterUnionID() {
  return Cookie.get(Consts.COOKIE_INVITER_UNIONID)
}

/**
 * 判断是否为淘口令
 */
export function isTbkey(str) {
  for (let item of TbKeyJson) {
    let i = str.indexOf(item.start)
    let j = str.lastIndexOf(item.end)
    let key = str.substring(i + item.start.length, j)
    if (i > -1 && j > i && !isEmpty(str) && key.length >= 6 && key.length <= 20) {
      return true
    }
  }
  return false
}

/**
 * 判断字符串是否为空
 * @param {*} str
 */
export function isEmpty(str) {
  if (str === null || str.trim() === '') {
    return true
  }
  for (let i = 0; i < str.length; i++) {
    let charAt = str.charAt(i)
    if (charAt !== ' ' && charAt != '\t' && charAt != '\r' && charAt != '\n') {
      return false
    }
  }
  return true
}
/**
 * 是否为 微信环境
 */
export function isWeiXin() {
  var ua = window.navigator.userAgent.toLowerCase()
  if (ua.indexOf('micromessenger') > -1) {
    return true
  } else {
    return false
  }
}
/**
 * 是否为董事惠商城APP
 */
export function isDshApp() {
  var ua = window.navigator.userAgent
  if (ua.indexOf('/Android/dshui_shop') > -1) {
    return true
  } else if (ua.indexOf('/IOS/dshui_shop') > -1) {
    return true
  } else {
    return false
  }
}

/**
   * 默认的用户信息
   */
export function getDefaultUserInfo() {
  return {
    token: '', // 用户令牌
    mobile: '', // 手机号
    cnName: '', // 昵称
    photo: '', // 头像
    email: '', // 邮箱
    regTime: '', // 注册时间
    dealerLevel: '', // 会员等级
    dealerLevelName: '', // 个人主页上显示的会员级别名称
    dealerLevelNameHuiCha: '', // 查查联盟中的会员级别名称
    secondLevelDomainID: '', // 二级域名ID
    secondLevelDomainName: '', // 二级域名名称
    secondLevelDomainUrl: '', // 二级域名链接地址,用于生成推广海报
    consumeMoney: 0, // 消费金额
  }
}

/**
 * 是否为 ios
 */
export function isIos() {
  const UA = navigator.userAgent
  const isIpad = /(iPad).*OS\s([\d_]+)/.test(UA)
  const isIpod = /(iPod)(.*OS\s([\d_]+))?/.test(UA)
  const isIphone = !isIpad && /(iPhone\sOS)\s([\d_]+)/.test(UA)
  const isIos = isIpad || isIpod || isIphone
  return isIos
}

/**
 * 格式化销量
 */
export function formatSaleCount(count) {
  let str = ''
  if (!isInt(count)) {
    return count
  }
  let i = parseInt(count)
  if (i < 100) {
    str = '100+'
  } else if (i < 1000) {
    str = `${parseInt(i / 100)}00+`
  } else if (i < 10000) {
    str = `${parseInt(i / 1000)}千+`
  } else if (i < 1000000) {
    str = `${parseInt(i / 10000)}万+`
  } else if (i < 10000000) {
    str = `${parseInt(i / 1000000)}百万+`
  } else if (i < 100000000) {
    str = `${parseInt(i / 10000000)}千万+`
  } else {
    str = `${parseInt(i / 100000000)}亿+`
  }
  return str
}

/**
 * 是否是正整数
 */
export function isInt(n) {
  return /^\+?[1-9][0-9]*$/.test(n)
}

/**
 * 转化http图片为相对协议图片,解决部分浏览器在https嵌套http资源时无法加载的问题
 */
export function formatHttpImg(imgUrl) {
  if (imgUrl.indexOf('http://') > -1) {
    return imgUrl.replace(/http:\/\//g, '//')
  }
  if (imgUrl.indexOf('https://') > -1) {
    return imgUrl.replace(/https:\/\//g, '//')
  }
  return imgUrl
}

export default Help
